import { Consumer } from '../../types'

const consumers: Consumer[] = [
	{ username: 'test' },
	{ username: 'test1' },
	{ username: 'test2' },
	{ username: 'test3' },
	{ username: 'test4' },
	{ username: 'test5' },
	{ username: 'test6' }
]

export default consumers
